import * as Sentry from "@sentry/vue";
import { createRouter, createWebHistory } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import redirectToHomeIfAuthorised from "@/shared/router/guards/redirectToHomeIfAuthorised";
import redirectToLoginIfUnauthorised from "@/shared/router/guards/redirectToLoginIfUnauthorised";
import routeBuilder from "@/shared/router/routeBuilder";

const routes = [
  {
    path: "/",
    component: () => import("@/shared/layouts/default/DefaultLayout.vue"),
    children: [
      {
        path: "/",
        redirect: { name: "auth.login" },
      },
      ...routeBuilder("default"),
    ],
    beforeEnter: redirectToLoginIfUnauthorised,
  },
  {
    path: "/",
    component: () => import("@/shared/layouts/unauthorised/UnauthorisedLayout.vue"),
    children: [
      {
        path: "/",
        redirect: { name: "auth.login" },
      },
      ...routeBuilder("unauthorised"),
    ],
    beforeEnter: redirectToHomeIfAuthorised,
  },
  {
    path: "/",
    component: () => import("@/shared/layouts/unauthorised/UnauthorisedLayout.vue"),
    children: [
      {
        path: "/",
        redirect: { name: "auth.login" },
      },
      ...routeBuilder("both"),
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "errors.notfound",
    component: () => import("@/shared/views/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    await useAuthorisationStore().syncClaims();
  } catch (e) {
    Sentry.captureException(e);
  }

  const currentVersion = import.meta.env.VITE_BUILD_HASH;

  if (!currentVersion) {
    next();
    return;
  }

  const response = await fetch("/version.json", { cache: "no-store" });
  const data = await response.json();

  if (data.version && data.version !== currentVersion) {
    window.location.reload();
  }
  next();
});

export default router;
